package net.frozenbit.games.soundgame

import kotlin.time.Duration

interface KeyValueStore {
    fun get(key: String): String?
    fun set(key: String, value: String, maxLifetime: Duration? = null)
    fun remove(key: String)
}
